/*add-an-empty-package*/
/*copy-an-existing-package*/
/*examples*/
/*custom-generators*/
/*getting-started*/
/*writing-generators*/
/*prompts*/
/*actions*/
/*running-generators*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "生成代码",
  "description": "了解如何使用 Turborepo 生成代码。"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "将你的 monorepo 拆分为包是组织代码、加快任务速度和改善本地开发体验的好方法。使用 Turborepo 的代码生成功能，你可以轻松地以结构化的方式为包、模块甚至单个 UI 组件生成新的源代码，并将其与存储库的其余部分集成。"
  }, {
    "heading": "",
    "content": "¥Splitting your monorepo into packages is a great way to organize your code, speed up tasks, and improve the local development\nexperience. With Turborepo's code generation, it's easy to generate new source code for packages, modules,\nand even individual UI components in a structured way that integrates with the rest of your repository."
  }, {
    "heading": "添加空包-add-an-empty-package",
    "content": "¥Add an empty package"
  }, {
    "heading": "添加空包-add-an-empty-package",
    "content": "将一个新的空应用或包添加到你的 monorepo 中。"
  }, {
    "heading": "添加空包-add-an-empty-package",
    "content": "¥Add a new, empty app or package to your monorepo."
  }, {
    "heading": "添加空包-add-an-empty-package",
    "content": "查看所有适用于 gen workspace 的 options。"
  }, {
    "heading": "添加空包-add-an-empty-package",
    "content": "¥View all available options for gen workspace."
  }, {
    "heading": "复制现有包-copy-an-existing-package",
    "content": "¥Copy an existing package"
  }, {
    "heading": "复制现有包-copy-an-existing-package",
    "content": "你可以将现有工作区用作新应用或软件包的模板。这适用于你现有 monorepo 中的工作区，以及来自其他存储库（通过 GitHub URL 指定）的远程工作区。"
  }, {
    "heading": "复制现有包-copy-an-existing-package",
    "content": "¥You can use an existing workspace as a template for your new app or package. This works for both workspaces within your existing monorepo,\nand remote workspaces from other repositories (specified via GitHub URL)."
  }, {
    "heading": "示例-examples",
    "content": "¥Examples"
  }, {
    "heading": "示例-examples",
    "content": "通过从代码库中现有的包复制，在你的 monorepo 中创建一个新包。"
  }, {
    "heading": "示例-examples",
    "content": "¥Create a new package in your monorepo by copying from an existing package in your repo."
  }, {
    "heading": "示例-examples",
    "content": "通过从远程包复制，在你的 monorepo 中创建一个新的工作区。"
  }, {
    "heading": "示例-examples",
    "content": "¥Create a new workspace in your monorepo by copying from a remote package."
  }, {
    "heading": "示例-examples",
    "content": "注意：从远程源添加时，Turborepo 无法验证你的代码库是否包含所有必需的依赖，以及是否使用了正确的包管理器。在这种情况下，可能需要进行一些手动修改才能使新的工作区在你的代码库中按预期工作。"
  }, {
    "heading": "示例-examples",
    "content": "¥Note: When adding from a remote source, Turborepo is unable to verify that your repo has all of the required dependencies, and is using the correct package manager. In this case, some manual modifications may be required to get the new workspace working as expected within your repository."
  }, {
    "heading": "示例-examples",
    "content": "查看所有适用于 gen workspace --copy 的 options。"
  }, {
    "heading": "示例-examples",
    "content": "¥View all available options for gen workspace --copy."
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥Custom generators"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "如果内置生成器无法满足你的需求，你可以使用 Plop 配置创建自己的自定义生成器。Turborepo 会自动检测你仓库中的所有生成器配置，并使它们可从命令行运行。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥If a built-in generator does not fit your needs, you can create your own custom generator using Plop configurations.\nTurborepo will automatically detect any generator configurations within your repo, and make them available to run from the command line."
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "虽然 Turborepo 生成器基于 Plop 构建，但它们不需要将 plop 作为依赖安装在你的代码库中。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥While Turborepo Generators are built on top of Plop, they don't require plop\nto be installed as a dependency in your repo."
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "Turborepo 可以理解所有 Plop 配置选项和功能，它还提供了几个附加功能来提升在配置了 Turborepo 的仓库中编写生成器的体验。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥While Turborepo understands all Plop configuration options and features, it provides a few additional features to improve the experience of writing\ngenerators within a repo configured with Turborepo."
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "生成器会在每个工作区自动发现、加载和组织（无需在单个配置文件中手动 load 生成器）。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥Generators are automatically discovered, loaded, and organized per workspace (no need to manually load them within a single configuration file)"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "生成器会自动从定义它们的工作区根目录运行。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥Generators are automatically run from the root of the workspace where they are defined"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "生成器可以在代码库中的任何位置调用（或通过 --root 标志在代码库外部调用）。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥Generators can be invoked from anywhere within your repo (or outside it via the --root flag)"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "TypeScript 生成器无需配置即可支持"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥TypeScript generators are supported with zero configuration"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "plop 不需要作为你的代码库的依赖安装。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥plop is not required to be installed as a dependency of your repo"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "自定义生成器目前不支持 ESM 依赖。"
  }, {
    "heading": "自定义生成器-custom-generators",
    "content": "¥ESM dependencies are not currently supported within custom generators."
  }, {
    "heading": "入门-getting-started",
    "content": "¥Getting started"
  }, {
    "heading": "入门-getting-started",
    "content": "要构建并运行自定义生成器，请使用 Turborepo 在 monorepo 中的任何位置运行以下命令。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥To build and run a custom generator, run the following command from anywhere within your monorepo using Turborepo."
  }, {
    "heading": "入门-getting-started",
    "content": "系统将提示你选择一个现有的生成器，或者如果你还没有生成器，则需要创建一个。你也可以在代码库根目录下的 turbo/generators/config.ts（或 config.js）手动创建配置。 - 或在任何工作区内。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥You'll be prompted to select an existing generator or to create one if you don't have any yet. You can also create your configuration\nmanually at turbo/generators/config.ts (or config.js) at the root of your repo - or within any workspace."
  }, {
    "heading": "入门-getting-started",
    "content": "如果你使用的是 TypeScript，则需要将 @turbo/gen 包 安装为 devDependency 才能访问所需的 TS 类型。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥If you are using TypeScript, you will need to install the @turbo/gen\npackage as\na devDependency to access the required TS types."
  }, {
    "heading": "入门-getting-started",
    "content": "例如，下面展示了一个包含三个生成器位置的 monorepo："
  }, {
    "heading": "入门-getting-started",
    "content": "¥For example, the following illustrates a monorepo with three locations for generators:"
  }, {
    "heading": "入门-getting-started",
    "content": "在工作区内创建的生成器会自动从工作区根目录运行，而不是代码库根目录，也不是生成器配置的位置。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥Generators created within workspaces are automatically run from the workspace root, not the repo root, nor the location of the generator configuration."
  }, {
    "heading": "入门-getting-started",
    "content": "这使得你的生成器更易于编写。在 [workspace-root] 目录下创建文件只需指定为 <file> 目录，而不是 ../../<file> 目录。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥This makes your generators more simple to write. Creating a file at [workspace-root] only needs to be specified as <file> rather than ../../<file>."
  }, {
    "heading": "入门-getting-started",
    "content": "了解更多关于 使用 Plop 创建自定义生成器 的信息。"
  }, {
    "heading": "入门-getting-started",
    "content": "¥Learn more about creating custom generators using Plop."
  }, {
    "heading": "正在编写生成器-writing-generators",
    "content": "¥Writing generators"
  }, {
    "heading": "正在编写生成器-writing-generators",
    "content": "生成器配置文件是一个返回 Plop 配置对象的函数。该配置对象用于定义生成器的提示和操作。"
  }, {
    "heading": "正在编写生成器-writing-generators",
    "content": "¥A generator configuration file is a function that returns a Plop configuration object. The configuration object is\nused to define the generator's prompts, and actions."
  }, {
    "heading": "正在编写生成器-writing-generators",
    "content": "最简单的生成器配置文件如下所示："
  }, {
    "heading": "正在编写生成器-writing-generators",
    "content": "¥In its simplest form, a generator configuration file looks like:"
  }, {
    "heading": "提示-prompts",
    "content": "¥Prompts"
  }, {
    "heading": "提示-prompts",
    "content": "提示符使用 Plop 提示 编写，用于收集用户信息。"
  }, {
    "heading": "提示-prompts",
    "content": "¥Prompts are written using Plop prompts and are used to gather information from the user."
  }, {
    "heading": "操作-actions",
    "content": "¥Actions"
  }, {
    "heading": "操作-actions",
    "content": "操作可以使用你自己定义的 内置 Plop 操作 或 自定义操作函数："
  }, {
    "heading": "操作-actions",
    "content": "¥Actions can use built-in Plop actions, or custom action functions that you define yourself:"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "¥Running generators"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "创建生成器配置文件后，你可以跳过选择提示，直接使用以下命令运行指定的生成器："
  }, {
    "heading": "运行生成器-running-generators",
    "content": "¥Once you have created your generator configuration file, you can skip the selection prompt and directly run a specified generator with:"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "也可以使用 --args 将参数直接传递给生成器提示符。"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "¥Arguments can also be passed directly to the generator prompts using --args"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "有关更多信息，请参阅 Plop 文档中的 绕过提示。"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "¥See bypassing prompts in the Plop documentation for more information."
  }, {
    "heading": "运行生成器-running-generators",
    "content": "查看所有适用于 gen 的 options。"
  }, {
    "heading": "运行生成器-running-generators",
    "content": "¥View all available options for gen."
  }],
  "headings": [{
    "id": "添加空包-add-an-empty-package",
    "content": "添加空包 /*add-an-empty-package*/"
  }, {
    "id": "复制现有包-copy-an-existing-package",
    "content": "复制现有包 /*copy-an-existing-package*/"
  }, {
    "id": "示例-examples",
    "content": "示例 /*examples*/"
  }, {
    "id": "自定义生成器-custom-generators",
    "content": "自定义生成器 /*custom-generators*/"
  }, {
    "id": "入门-getting-started",
    "content": "入门 /*getting-started*/"
  }, {
    "id": "正在编写生成器-writing-generators",
    "content": "正在编写生成器 /*writing-generators*/"
  }, {
    "id": "提示-prompts",
    "content": "提示 /*prompts*/"
  }, {
    "id": "操作-actions",
    "content": "操作 /*actions*/"
  }, {
    "id": "运行生成器-running-generators",
    "content": "运行生成器 /*running-generators*/"
  }]
};
import {Callout} from '#components/callout';
import {File, Folder, Files} from '#components/files';
import {Tabs, Tab} from 'fumadocs-ui/components/tabs';
export const toc = [{
  depth: 2,
  url: "#添加空包-add-an-empty-package",
  title: _jsx(_Fragment, {
    children: "添加空包 "
  })
}, {
  depth: 2,
  url: "#复制现有包-copy-an-existing-package",
  title: _jsx(_Fragment, {
    children: "复制现有包 "
  })
}, {
  depth: 3,
  url: "#示例-examples",
  title: _jsx(_Fragment, {
    children: "示例 "
  })
}, {
  depth: 2,
  url: "#自定义生成器-custom-generators",
  title: _jsx(_Fragment, {
    children: "自定义生成器 "
  })
}, {
  depth: 3,
  url: "#入门-getting-started",
  title: _jsx(_Fragment, {
    children: "入门 "
  })
}, {
  depth: 3,
  url: "#正在编写生成器-writing-generators",
  title: _jsx(_Fragment, {
    children: "正在编写生成器 "
  })
}, {
  depth: 4,
  url: "#提示-prompts",
  title: _jsx(_Fragment, {
    children: "提示 "
  })
}, {
  depth: 4,
  url: "#操作-actions",
  title: _jsx(_Fragment, {
    children: "操作 "
  })
}, {
  depth: 3,
  url: "#运行生成器-running-generators",
  title: _jsx(_Fragment, {
    children: "运行生成器 "
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    em: "em",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    li: "li",
    ol: "ol",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "将你的 monorepo 拆分为包是组织代码、加快任务速度和改善本地开发体验的好方法。使用 Turborepo 的代码生成功能，你可以轻松地以结构化的方式为包、模块甚至单个 UI 组件生成新的源代码，并将其与存储库的其余部分集成。"
    }), "\n", _jsx(_components.p, {
      children: "¥Splitting your monorepo into packages is a great way to organize your code, speed up tasks, and improve the local development\nexperience. With Turborepo's code generation, it's easy to generate new source code for packages, modules,\nand even individual UI components in a structured way that integrates with the rest of your repository."
    }), "\n", _jsx(_components.h2, {
      id: "添加空包-add-an-empty-package",
      children: "添加空包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Add an empty package"
    }), "\n", _jsx(_components.p, {
      children: "将一个新的空应用或包添加到你的 monorepo 中。"
    }), "\n", _jsx(_components.p, {
      children: "¥Add a new, empty app or package to your monorepo."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["查看所有适用于 ", _jsx(_components.code, {
        children: "gen workspace"
      }), " 的 ", _jsx(_components.a, {
        href: "/docs/reference/generate#workspace",
        children: "options"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥View all available ", _jsx(_components.a, {
        href: "/docs/reference/generate#workspace",
        children: "options"
      }), " for ", _jsx(_components.code, {
        children: "gen workspace"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "复制现有包-copy-an-existing-package",
      children: "复制现有包 "
    }), "\n", _jsx(_components.p, {
      children: "¥Copy an existing package"
    }), "\n", _jsx(_components.p, {
      children: "你可以将现有工作区用作新应用或软件包的模板。这适用于你现有 monorepo 中的工作区，以及来自其他存储库（通过 GitHub URL 指定）的远程工作区。"
    }), "\n", _jsx(_components.p, {
      children: "¥You can use an existing workspace as a template for your new app or package. This works for both workspaces within your existing monorepo,\nand remote workspaces from other repositories (specified via GitHub URL)."
    }), "\n", _jsx(_components.h3, {
      id: "示例-examples",
      children: "示例 "
    }), "\n", _jsx(_components.p, {
      children: "¥Examples"
    }), "\n", _jsx(_components.p, {
      children: "通过从代码库中现有的包复制，在你的 monorepo 中创建一个新包。"
    }), "\n", _jsx(_components.p, {
      children: "¥Create a new package in your monorepo by copying from an existing package in your repo."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --copy"
            })]
          })
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "通过从远程包复制，在你的 monorepo 中创建一个新的工作区。"
    }), "\n", _jsx(_components.p, {
      children: "¥Create a new workspace in your monorepo by copying from a remote package."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " workspace"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " --copy"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " https://github.com/vercel/turborepo/tree/main/examples/with-tailwind/packages/tailwind-config"
            })]
          })
        })
      })
    }), "\n", _jsxs(Callout, {
      children: [_jsx(_components.p, {
        children: "注意：从远程源添加时，Turborepo 无法验证你的代码库是否包含所有必需的依赖，以及是否使用了正确的包管理器。在这种情况下，可能需要进行一些手动修改才能使新的工作区在你的代码库中按预期工作。"
      }), _jsxs(_components.p, {
        children: ["¥", _jsx(_components.strong, {
          children: "Note"
        }), ": When adding from a remote source, Turborepo is unable to verify that your repo has all of the required dependencies, and is using the correct package manager. In this case, some manual modifications may be required to get the new workspace working as expected within your repository."]
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["查看所有适用于 ", _jsx(_components.code, {
        children: "gen workspace --copy"
      }), " 的 ", _jsx(_components.a, {
        href: "/docs/reference/generate#workspace",
        children: "options"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥View all available ", _jsx(_components.a, {
        href: "/docs/reference/generate#workspace",
        children: "options"
      }), " for ", _jsx(_components.code, {
        children: "gen workspace --copy"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "自定义生成器-custom-generators",
      children: "自定义生成器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Custom generators"
    }), "\n", _jsxs(_components.p, {
      children: ["如果内置生成器无法满足你的需求，你可以使用 ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " 配置创建自己的自定义生成器。Turborepo 会自动检测你仓库中的所有生成器配置，并使它们可从命令行运行。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥If a built-in generator does not fit your needs, you can create your own custom generator using ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " configurations.\nTurborepo will automatically detect any generator configurations within your repo, and make them available to run from the command line."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["虽然 Turborepo 生成器基于 Plop 构建，但它们不需要将 ", _jsx(_components.code, {
          children: "plop"
        }), " 作为依赖安装在你的代码库中。"]
      }), _jsxs(_components.p, {
        children: ["¥While Turborepo Generators are built on top of Plop, they don't require ", _jsx(_components.code, {
          children: "plop"
        }), "\nto be installed as a dependency in your repo."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 可以理解所有 Plop 配置选项和功能，它还提供了几个附加功能来提升在配置了 Turborepo 的仓库中编写生成器的体验。"
    }), "\n", _jsx(_components.p, {
      children: "¥While Turborepo understands all Plop configuration options and features, it provides a few additional features to improve the experience of writing\ngenerators within a repo configured with Turborepo."
    }), "\n", _jsxs(_components.ol, {
      children: ["\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["生成器会在每个工作区自动发现、加载和组织（无需在单个配置文件中手动 ", _jsx(_components.code, {
            children: "load"
          }), " 生成器）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Generators are automatically discovered, loaded, and organized per workspace (no need to manually ", _jsx(_components.code, {
            children: "load"
          }), " them within a single configuration file)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "生成器会自动从定义它们的工作区根目录运行。"
        }), "\n", _jsx(_components.p, {
          children: "¥Generators are automatically run from the root of the workspace where they are defined"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: ["生成器可以在代码库中的任何位置调用（或通过 ", _jsx(_components.a, {
            href: "/docs/reference/generate#--root-path",
            children: _jsx(_components.code, {
              children: "--root"
            })
          }), " 标志在代码库外部调用）。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥Generators can be invoked from anywhere within your repo (or outside it via the ", _jsx(_components.a, {
            href: "/docs/reference/generate#--root-path",
            children: _jsx(_components.code, {
              children: "--root"
            })
          }), " flag)"]
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsx(_components.p, {
          children: "TypeScript 生成器无需配置即可支持"
        }), "\n", _jsx(_components.p, {
          children: "¥TypeScript generators are supported with zero configuration"
        }), "\n"]
      }), "\n", _jsxs(_components.li, {
        children: ["\n", _jsxs(_components.p, {
          children: [_jsx(_components.code, {
            children: "plop"
          }), " 不需要作为你的代码库的依赖安装。"]
        }), "\n", _jsxs(_components.p, {
          children: ["¥", _jsx(_components.code, {
            children: "plop"
          }), " is not required to be installed as a dependency of your repo"]
        }), "\n"]
      }), "\n"]
    }), "\n", _jsxs(Callout, {
      type: "info",
      title: "Known issue",
      children: [_jsx(_components.p, {
        children: "自定义生成器目前不支持 ESM 依赖。"
      }), _jsx(_components.p, {
        children: "¥ESM dependencies are not currently supported within custom generators."
      })]
    }), "\n", _jsx(_components.h3, {
      id: "入门-getting-started",
      children: "入门 "
    }), "\n", _jsx(_components.p, {
      children: "¥Getting started"
    }), "\n", _jsx(_components.p, {
      children: "要构建并运行自定义生成器，请使用 Turborepo 在 monorepo 中的任何位置运行以下命令。"
    }), "\n", _jsx(_components.p, {
      children: "¥To build and run a custom generator, run the following command from anywhere within your monorepo using Turborepo."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["系统将提示你选择一个现有的生成器，或者如果你还没有生成器，则需要创建一个。你也可以在代码库根目录下的 ", _jsx(_components.code, {
        children: "turbo/generators/config.ts"
      }), "（或 ", _jsx(_components.code, {
        children: "config.js"
      }), "）手动创建配置。 - 或在任何工作区内。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥You'll be prompted to select an existing generator or to create one if you don't have any yet. You can also create your configuration\nmanually at ", _jsx(_components.code, {
        children: "turbo/generators/config.ts"
      }), " (or ", _jsx(_components.code, {
        children: "config.js"
      }), ") at the root of your repo - or within ", _jsx(_components.em, {
        children: "any"
      }), " workspace."]
    }), "\n", _jsxs(Callout, {
      type: "info",
      children: [_jsxs(_components.p, {
        children: ["如果你使用的是 TypeScript，则需要将 ", _jsxs(_components.a, {
          href: "https://github.com/vercel/turborepo/tree/main/packages/turbo-gen",
          children: [_jsx(_components.code, {
            children: "@turbo/gen"
          }), " 包"]
        }), " 安装为 ", _jsx(_components.code, {
          children: "devDependency"
        }), " 才能访问所需的 TS 类型。"]
      }), _jsxs(_components.p, {
        children: ["¥If you are using TypeScript, you will need to install ", _jsxs(_components.a, {
          href: "https://github.com/vercel/turborepo/tree/main/packages/turbo-gen",
          children: ["the ", _jsx(_components.code, {
            children: "@turbo/gen"
          }), "\npackage"]
        }), " as\na ", _jsx(_components.code, {
          children: "devDependency"
        }), " to access the required TS types."]
      })]
    }), "\n", _jsx(_components.p, {
      children: "例如，下面展示了一个包含三个生成器位置的 monorepo："
    }), "\n", _jsx(_components.p, {
      children: "¥For example, the following illustrates a monorepo with three locations for generators:"
    }), "\n", _jsxs(Tabs, {
      groupId: "package-manager",
      items: ['pnpm', 'yarn', 'npm', 'bun'],
      persist: true,
      children: [_jsx(Tab, {
        value: "pnpm",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "package-lock.yaml"
          }), _jsx(File, {
            name: "pnpm-workspace.yaml"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      }), _jsx(Tab, {
        value: "yarn",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "yarn.lock"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      }), _jsx(Tab, {
        value: "npm",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "package-lock.json"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      }), _jsx(Tab, {
        value: "bun",
        children: _jsxs(Files, {
          children: [_jsxs(Folder, {
            name: "apps",
            defaultOpen: true,
            children: [_jsx(Folder, {
              name: "docs",
              children: _jsx(File, {
                name: "package.json"
              })
            }), _jsxs(Folder, {
              name: "web",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })]
          }), _jsx(Folder, {
            name: "packages",
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "ui",
              defaultOpen: true,
              children: [_jsx(File, {
                name: "package.json"
              }), _jsx(Folder, {
                name: "turbo",
                green: true,
                defaultOpen: true,
                children: _jsxs(Folder, {
                  name: "generators",
                  children: [_jsx(File, {
                    name: "config.ts"
                  }), _jsx(File, {
                    name: "templates"
                  })]
                })
              })]
            })
          }), _jsx(Folder, {
            name: "turbo",
            green: true,
            defaultOpen: true,
            children: _jsxs(Folder, {
              name: "generators",
              children: [_jsx(File, {
                name: "config.ts"
              }), _jsx(File, {
                name: "templates"
              })]
            })
          }), _jsx(File, {
            name: "package.json"
          }), _jsx(File, {
            name: "bun.lock"
          }), _jsx(File, {
            name: "turbo.json"
          })]
        })
      })]
    }), "\n", _jsx(_components.p, {
      children: "在工作区内创建的生成器会自动从工作区根目录运行，而不是代码库根目录，也不是生成器配置的位置。"
    }), "\n", _jsxs(_components.p, {
      children: ["¥Generators created within workspaces are automatically run from the workspace root, ", _jsx(_components.strong, {
        children: "not"
      }), " the repo root, nor the location of the generator configuration."]
    }), "\n", _jsxs(_components.p, {
      children: ["这使得你的生成器更易于编写。在 ", _jsx(_components.code, {
        children: "[workspace-root]"
      }), " 目录下创建文件只需指定为 ", _jsx(_components.code, {
        children: "<file>"
      }), " 目录，而不是 ", _jsx(_components.code, {
        children: "../../<file>"
      }), " 目录。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥This makes your generators more simple to write. Creating a file at ", _jsx(_components.code, {
        children: "[workspace-root]"
      }), " only needs to be specified as ", _jsx(_components.code, {
        children: "<file>"
      }), " rather than ", _jsx(_components.code, {
        children: "../../<file>"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["了解更多关于 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#creating-a-generator",
        children: "使用 Plop 创建自定义生成器"
      }), " 的信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Learn more about ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#creating-a-generator",
        children: "creating custom generators using Plop"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "正在编写生成器-writing-generators",
      children: "正在编写生成器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Writing generators"
    }), "\n", _jsxs(_components.p, {
      children: ["生成器配置文件是一个返回 ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " 配置对象的函数。该配置对象用于定义生成器的提示和操作。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥A generator configuration file is a function that returns a ", _jsx(_components.a, {
        href: "https://plopjs.com/",
        children: "Plop"
      }), " configuration object. The configuration object is\nused to define the generator's prompts, and actions."]
    }), "\n", _jsx(_components.p, {
      children: "最简单的生成器配置文件如下所示："
    }), "\n", _jsx(_components.p, {
      children: "¥In its simplest form, a generator configuration file looks like:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo/generators/config.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { PlopTypes } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@turbo/gen\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " generator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "(plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " PlopTypes"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "NodePlopAPI"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ")"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " void"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // create a generator"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "  plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".setGenerator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"Generator name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    description"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"Generator description\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // gather information from the user"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    prompts"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "    // perform actions based on the prompts"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    actions"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  });"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h4, {
      id: "提示-prompts",
      children: "提示 "
    }), "\n", _jsx(_components.p, {
      children: "¥Prompts"
    }), "\n", _jsxs(_components.p, {
      children: ["提示符使用 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#using-prompts",
        children: "Plop 提示"
      }), " 编写，用于收集用户信息。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Prompts are written using ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#using-prompts",
        children: "Plop prompts"
      }), " and are used to gather information from the user."]
    }), "\n", _jsx(_components.h4, {
      id: "操作-actions",
      children: "操作 "
    }), "\n", _jsx(_components.p, {
      children: "¥Actions"
    }), "\n", _jsxs(_components.p, {
      children: ["操作可以使用你自己定义的 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#built-in-actions",
        children: "内置 Plop 操作"
      }), " 或 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#functionsignature-custom-action",
        children: "自定义操作函数"
      }), "："]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Actions can use ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#built-in-actions",
        children: "built-in Plop actions"
      }), ", or ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#functionsignature-custom-action",
        children: "custom action functions"
      }), " that you define yourself:"]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "turbo/generators/config.ts",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M1.125 0C.502 0 0 .502 0 1.125v21.75C0 23.498.502 24 1.125 24h21.75c.623 0 1.125-.502 1.125-1.125V1.125C24 .502 23.498 0 22.875 0zm17.363 9.75c.612 0 1.154.037 1.627.111a6.38 6.38 0 0 1 1.306.34v2.458a3.95 3.95 0 0 0-.643-.361 5.093 5.093 0 0 0-.717-.26 5.453 5.453 0 0 0-1.426-.2c-.3 0-.573.028-.819.086a2.1 2.1 0 0 0-.623.242c-.17.104-.3.229-.393.374a.888.888 0 0 0-.14.49c0 .196.053.373.156.529.104.156.252.304.443.444s.423.276.696.41c.273.135.582.274.926.416.47.197.892.407 1.266.628.374.222.695.473.963.753.268.279.472.598.614.957.142.359.214.776.214 1.253 0 .657-.125 1.21-.373 1.656a3.033 3.033 0 0 1-1.012 1.085 4.38 4.38 0 0 1-1.487.596c-.566.12-1.163.18-1.79.18a9.916 9.916 0 0 1-1.84-.164 5.544 5.544 0 0 1-1.512-.493v-2.63a5.033 5.033 0 0 0 3.237 1.2c.333 0 .624-.03.872-.09.249-.06.456-.144.623-.25.166-.108.29-.234.373-.38a1.023 1.023 0 0 0-.074-1.089 2.12 2.12 0 0 0-.537-.5 5.597 5.597 0 0 0-.807-.444 27.72 27.72 0 0 0-1.007-.436c-.918-.383-1.602-.852-2.053-1.405-.45-.553-.676-1.222-.676-2.005 0-.614.123-1.141.369-1.582.246-.441.58-.804 1.004-1.089a4.494 4.494 0 0 1 1.47-.629 7.536 7.536 0 0 1 1.77-.201zm-15.113.188h9.563v2.166H9.506v9.646H6.789v-9.646H3.375z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "import"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " type"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " { PlopTypes } "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "from"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"@turbo/gen\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " customAction"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " PlopTypes"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "CustomActionFunction"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " async"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " (answers) "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "=>"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // fetch data from a remote API"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  const"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " results"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " ="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " await"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " fetchRemoteData"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "();"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // add the response to the answers, making this data available to actions"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "  answers"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ".results "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "="
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " results;"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // return a status string"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "  return"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " 'Finished data fetching!'"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ";"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: " "
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "export"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " default"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: " function"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " generator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "(plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: " PlopTypes"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "."
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "NodePlopAPI"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ")"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: " void"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "  // create a generator"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "  plop"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: ".setGenerator"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "("
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"Generator name\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    description"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"Generator description\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    prompts"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    actions"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: ":"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " ["
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      customAction"
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      {"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-comment)",
                "--shiki-dark": "var(--shiki-token-comment)"
              },
              children: "/* actions now have access to `answers.results` */"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "      ..."
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    ]"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-punctuation)",
                "--shiki-dark": "var(--shiki-token-punctuation)"
              },
              children: ","
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  });"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "运行生成器-running-generators",
      children: "运行生成器 "
    }), "\n", _jsx(_components.p, {
      children: "¥Running generators"
    }), "\n", _jsx(_components.p, {
      children: "创建生成器配置文件后，你可以跳过选择提示，直接使用以下命令运行指定的生成器："
    }), "\n", _jsx(_components.p, {
      children: "¥Once you have created your generator configuration file, you can skip the selection prompt and directly run a specified generator with:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name]"
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["也可以使用 ", _jsx(_components.code, {
        children: "--args"
      }), " 将参数直接传递给生成器提示符。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥Arguments can also be passed directly to the generator prompts using ", _jsx(_components.code, {
        children: "--args"
      })]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsx(_components.code, {
          children: _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " gen"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " [generator-name] --args answer1 answer2 ..."
            })]
          })
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["有关更多信息，请参阅 Plop 文档中的 ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#bypassing-prompts",
        children: "绕过提示"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥See ", _jsx(_components.a, {
        href: "https://plopjs.com/documentation/#bypassing-prompts",
        children: "bypassing prompts"
      }), " in the Plop documentation for more information."]
    }), "\n", _jsxs(_components.p, {
      children: ["查看所有适用于 ", _jsx(_components.code, {
        children: "gen"
      }), " 的 ", _jsx(_components.a, {
        href: "/docs/reference/generate#run-generator-name",
        children: "options"
      }), "。"]
    }), "\n", _jsxs(_components.p, {
      children: ["¥View all available ", _jsx(_components.a, {
        href: "/docs/reference/generate#run-generator-name",
        children: "options"
      }), " for ", _jsx(_components.code, {
        children: "gen"
      }), "."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
